module.exports = __webpack_public_path__ + "static/media/li-icon.f64221d9.svg";